/* -------------------------------------------------------------------------- */
/*                        AJAX filtering for vacatures                        */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  jQuery(function ($) {
    // Function to perform AJAX request
    function fetchJobs(paged = 1) {
      // Get the selected values
      const jobLevel = $("#job-level").val();
      const jobHours = $("#job-hours").val();
      const jobRegion = $("#job-region").val();
      const jobKind = $("#job-kind").val();

      // Prepare the data to be sent via AJAX
      const data = {
        action: "vacature_filtering",
        jobLevel: jobLevel,
        jobHours: jobHours,
        jobRegion: jobRegion,
        jobKind: jobKind,
        paged: paged,
      };

      // Perform the AJAX request
      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        dataType: "html",
        data: data,
        beforeSend: function () {
          // Optional: Add a loading spinner or message
        },
        success: function (res) {
          $(".job-overview__wrapper").html(res);

          // Re-bind the click event for pagination links
          $(".posts-navigation a").on("click", function (e) {
            e.preventDefault();
            const paged = $(this).attr("href").split("paged=")[1];
            fetchJobs(paged);
          });
        },
        error: function (xhr, status, error) {
          console.error("AJAX Error:", status, error);
        },
      });
    }

    // Event listener for search button
    $("#search-jobs").on("click", function (e) {
      e.preventDefault();
      fetchJobs();

      $("#reset-filter").addClass("active");
    });

    // Initial fetch to load the first page of jobs
    fetchJobs();
  });
});
